import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { IconSearch } from '@components/icons/search';

import { useStore } from 'models/stores';

import EmptyStateCard from './EmptyStateCard';

export default function Job404() {
  const { uiStore, companyStore } = useStore();
  const company = companyStore.current.name;
  const jobListUrl = `/${company}/${uiStore.language}`;

  return (
    <EmptyStateCard
      icon={<IconSearch />}
      heading={uiStore.t('job_does_not_exist_header')}
      sub={uiStore.t('job_does_not_exist_sub_header')}
    >
      <BackLink>
        <Link to={jobListUrl}>{uiStore.t('job_does_not_exist_link')}</Link>
      </BackLink>
    </EmptyStateCard>
  );
}

const BackLink = styled.div`
  margin-top: 12px;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.primaryColor};

  a {
    color: inherit;
  }
`;
